import React from 'react';

import { observer } from 'mobx-react-lite';
import { useStore } from '@vromo/mobx-react';

import { Group } from '@vromo/models';

import orderBy from 'lodash/orderBy';

import Table from '@vromo/ui/components/Table';
import { ProfilePlaceholder } from '@vromo/ui/components/ProfileImage';
import { GroupJob, JobStats } from './DashboardRoot.lazy';

export const TeamRow = observer<{ group: Group; completeJobs: number }>(function TeamRow({
    group,
    completeJobs
}) {
    if (!group?.name || !group?.id) {
        return <></>;
    }
    return (
        <tr>
            <td>
                <ProfilePlaceholder initials={group?.name.trim()[0] || ''} id={group?.id} />
            </td>
            <td>{group?.name}</td>
            <td style={{ textAlign: 'center' }}>{completeJobs}</td>
        </tr>
    );
});

export default observer<{ jobStats: JobStats | Record<string, never> }>(function TopTeams({
    jobStats
}) {
    const { groupStore } = useStore('rootStore');

    const renderTeams = (jobsPerGroup: Array<GroupJob>) => {
        return (
            <Table>
                <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th style={{ textAlign: 'center' }}>Jobs Completed</th>
                    </tr>
                </thead>
                <tbody>
                    {orderBy(jobsPerGroup, (g) => g.completeJobs, ['desc'])
                        .filter((g) => groupStore.withId(g.group) !== undefined)
                        .slice(0, 6)
                        .map((g) => (
                            <TeamRow
                                key={g.group}
                                group={groupStore.withId(g.group)}
                                completeJobs={g.completeJobs}
                            />
                        ))}
                </tbody>
            </Table>
        );
    };

    const renderEmpty = () => (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
            }}>
            No jobs completed by any teams.
        </div>
    );

    return (
        <div
            style={{
                height: '80%',
                marginTop: '15px'
            }}>
            {groupStore.loaded && jobStats?.jobsPerGroup?.length
                ? renderTeams(jobStats?.jobsPerGroup)
                : renderEmpty()}
        </div>
    );
});
